import { render, staticRenderFns } from "./ConfigurazioneContabilitaTabellaIvaListPage.vue?vue&type=template&id=4b1d9899"
import script from "./ConfigurazioneContabilitaTabellaIvaListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTabellaIvaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports